import { getEnglishInitials } from "../../../components/UserAvatar";

// ✅ getUserInitials - Uses shared English-only initials (NEVER Arabic)
export const getUserInitials = (name, englishName = null) => {
  return getEnglishInitials(name, englishName, "US");
};
